import React, { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useAuth } from '../context/AuthContext';
import { sanitizeNameInput } from '../utils/validation';
import './Auth.css';

const Signup = () => {
  const { t, i18n } = useTranslation();
  const navigate = useNavigate();
  const { signup } = useAuth();
  const [formData, setFormData] = useState({
    email: '',
    password: '',
    password_confirm: '',
    nom: '',
    prenom: '',
    langue: 'fr',
    pays: '',
    age: '',
  });
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const handleChange = (e) => {
    const { name, value } = e.target;
    const sanitized = (name === 'prenom' || name === 'nom') ? sanitizeNameInput(value) : value;
    setFormData({
      ...formData,
      [name]: sanitized,
    });
    setError('');
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');

    if (formData.password !== formData.password_confirm) {
      setError('Les mots de passe ne correspondent pas');
      setLoading(false);
      return;
    }

    const result = await signup(formData);
    
    console.log('Signup result:', result);
    
    if (result.success) {
      // Appliquer la langue choisie et rediriger vers la page de vérification d'email
      i18n.changeLanguage(formData.langue);
      localStorage.setItem('language', formData.langue);
      navigate('/verify-email', { state: { email: formData.email, langue: formData.langue } });
    } else {
      console.error('Signup error:', result.error);
      const errorMessage = result.error?.message || 
        (typeof result.error === 'string' ? result.error : Object.values(result.error || {}).flat().join(', ')) ||
        'Erreur d\'inscription';
      setError(errorMessage);
    }
    
    setLoading(false);
  };

  return (
    <div className="auth-container">
      <div className="auth-main auth-main-no-nav">
        <div className="auth-content-wrapper">
          <div className="auth-card">
        <h1>{t('auth.signup')}</h1>
        {error && <div className="error-message">{error}</div>}
        <form onSubmit={handleSubmit}>
          <div className="form-group">
            <label htmlFor="email">{t('auth.email')}</label>
            <input
              type="email"
              id="email"
              name="email"
              value={formData.email}
              onChange={handleChange}
              required
            />
          </div>
          <div className="form-group">
            <label htmlFor="prenom">{t('auth.firstName')}</label>
            <input
              type="text"
              id="prenom"
              name="prenom"
              value={formData.prenom}
              onChange={handleChange}
            />
          </div>
          <div className="form-group">
            <label htmlFor="nom">{t('auth.lastName')}</label>
            <input
              type="text"
              id="nom"
              name="nom"
              value={formData.nom}
              onChange={handleChange}
            />
          </div>
          <div className="form-group">
            <label htmlFor="password">{t('auth.password')}</label>
            <input
              type="password"
              id="password"
              name="password"
              value={formData.password}
              onChange={handleChange}
              required
              minLength={8}
            />
          </div>
          <div className="form-group">
            <label htmlFor="password_confirm">{t('auth.confirmPassword')}</label>
            <input
              type="password"
              id="password_confirm"
              name="password_confirm"
              value={formData.password_confirm}
              onChange={handleChange}
              required
              minLength={8}
            />
          </div>
          <div className="form-group">
            <label htmlFor="langue">{t('auth.language')}</label>
            <select
              id="langue"
              name="langue"
              value={formData.langue}
              onChange={handleChange}
            >
              <option value="fr">Français</option>
              <option value="en">English</option>
              <option value="es">Español</option>
              <option value="pt">Português</option>
              <option value="de">Deutsch</option>
              <option value="it">Italiano</option>
              <option value="tr">Türkçe</option>
              <option value="pl">Polski</option>
              <option value="ru">Русский</option>
              <option value="uk">Українська</option>
            </select>
          </div>
          <div className="form-group">
            <label htmlFor="pays">{t('auth.country')}</label>
            <input
              type="text"
              id="pays"
              name="pays"
              value={formData.pays}
              onChange={handleChange}
            />
          </div>
          <div className="form-group">
            <label htmlFor="age">{t('auth.age')}</label>
            <input
              type="number"
              id="age"
              name="age"
              value={formData.age}
              onChange={handleChange}
              min="1"
              max="120"
            />
          </div>
          <button type="submit" disabled={loading} className="submit-button">
            {loading ? 'Inscription...' : t('auth.submit')}
          </button>
        </form>
        <p className="auth-link">
          Déjà un compte ? <Link to="/login">{t('auth.login')}</Link>
        </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Signup;

